import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignCategoryIdReducer = (state: DesignState, action: PayloadAction<number | undefined>) => {
  state.categoryId = action.payload;
};

export default setDesignCategoryIdReducer;
